import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import { getHost } from '../../../const';
import { query } from '../../../lib/util/common';
import './index.scss';
let lock = false;
class VerifyNoticeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  jump2verify = () => {
    if (lock) return;
    lock = true;
    const { verifyUrl = '' } = this.props.myIntegral || {};
    // const verifyUrl = 'https://qbact.sparta.html5.qq.com/verification/#/';
    const backUrl = `${getHost()}/newtickets_v2/#/withDraw`;
    this.close();
    lock = false;
    const kbgodvconsole = query('kbgodvconsole') ? '1' : '';
    if (window.browser && window.browser.app && window.browser.app.openUrl) {
      window.browser.app.openUrl(null, null, { url: `${verifyUrl}?kbgodvconsole=${kbgodvconsole}&refer=welfare&url=${encodeURIComponent(backUrl)}` });
    } else {
      return window.location.href = `${verifyUrl}?refer=welfare&kbgodvconsole=${kbgodvconsole}&url=${encodeURIComponent(backUrl)}`;
    }
  }

  close = () => {
    this.props.dialogs.pop();
    this.props.dispatch(setDialogs(this.props.dialogs));
  }

  render() {
    return (
        <div className="verify-dialog-mask">
            <div className="verify-dialog-wrap">
                <div className="m-title">温馨提示</div>
                <div className="m-desc">为了保证您的资金安全<br />请验证身份信息</div>
                <div className="m-ok-button" onClick={this.jump2verify}>前往验证</div>
                <div className="m-cancel-button" onClick={this.close}>取消</div>
            </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { dialogs, myIntegral } = state;
  return {
    dialogs,
    myIntegral,
  };
};

export default connect(mapStateToProps)(VerifyNoticeDialog);
